import React, { memo, forwardRef } from "react";
const SvgEquivalent = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M11.341 8.247a1 1 0 011.318 1.506L10.09 12h11.82l-2.569-2.247a1 1 0 011.317-1.506l8 7a1 1 0 010 1.506l-8 7a1 1 0 11-1.317-1.506L21.91 20H10.09l2.569 2.247a1 1 0 11-1.318 1.506l-8-7a1 1 0 010-1.505l8-7zm-3.519 9.769A1.01 1.01 0 018 18h16c.06 0 .12.006.178.016L26.48 16l-2.303-2.016c-.058.01-.117.016-.178.016H8a1 1 0 01-.178-.016L5.52 16l2.303 2.016z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgEquivalent.displayName = "SvgEquivalent";
const MemoForwardRef = memo(SvgEquivalent);
export default MemoForwardRef;
